import { Http } from '@/lib/http';

export class AuditLogService extends Http {
  constructor() {
    super();
    this.endpoint = 'settings/system-settings/audit-logs';
  }

  findAll(obj) {
    return this.httpClient().get(`${this.endpoint}`, {
      params: obj
    });
  }
  exportLogs(obj) {
    return this.httpClient().get(`${this.endpoint}/export`, {
      params: obj
    });
  }

  findAllModules() {
    return this.httpClient().get(`${this.endpoint}/modules`);
  }

  findAllActions() {
    return this.httpClient().get(`${this.endpoint}/actions`);
  }
}
